export const loopiColors = {
  50: '#FDE7F2',
  100: '#FBD0E7',
  200: '#F59ECF',
  300: '#EF6EB7',
  400: '#E64B9F',
  500: '#D94088',
  600: '#BF2F75',
  700: '#A22563',
  800: '#851B51',
  900: '#69133F',
  DEFAULT: '#D94088',
};

export const loopiInk = {
  50: '#F8F3F6',
  100: '#F0E6EC',
  200: '#DEC9D5',
  300: '#C59FB3',
  400: '#A9718F',
  500: '#88556F',
  600: '#673B52',
  700: '#472538',
  800: '#2A151F',
  900: '#14090F',
  950: '#090306',
};

export const loopiNeutral = {
  0: '#FFFFFF',
  50: '#FFF8FB',
  100: '#FDF0F6',
  200: '#F8E3EC',
  300: '#EED0DE',
  400: '#D8AABD',
  500: '#B97A94',
  600: '#945B73',
  700: '#6A3E53',
  800: '#422635',
  900: '#23161C',
};

export const loopiSemantic = {
  success: '#3AA76D',
  warning: '#F3A847',
  error: '#E35B66',
  info: loopiColors[500],
};

const colors = {
  loopi: loopiColors,
  ink: loopiInk,
  neutral: loopiNeutral,
  semantic: loopiSemantic,
};

export default colors;
